import { render, staticRenderFns } from "./SelectTemplateOrWorkflow.vue?vue&type=template&id=b3401638&scoped=true&"
import script from "./SelectTemplateOrWorkflow.vue?vue&type=script&lang=js&"
export * from "./SelectTemplateOrWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./SelectTemplateOrWorkflow.vue?vue&type=style&index=0&id=b3401638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3401638",
  null
  
)

export default component.exports